

























































































































import BaseComponent from "@/asdcom/BaseComponent";
import { Component } from "vue-property-decorator";
import util from "@/lib/util";
import {
  ClaimsTasksDto,
  IPagedAndSortedInputDto,
  PagedAndSortedInputDto,
  VcClaimSummaryLightDto,
  VcClaimDto,
  ClaimTaskDto,
  SearchVcClaimInput
} from "@/asdcom/apiproxy/apiproxy.dto";
import { IHeader } from "@/store/models/staff/IHeader";
import ClaimListComponent from "@/components/vcponlineok/claim-list-component.vue";
import bus from "@/components/vcponlineok/bus/bus.js";

interface ISearchCriteria {
  VictimLastName: string;
  ClaimNumber: string;
  AssignedCounty: string;
}

@Component({
  components: {
    ClaimListComponent
  }
})
export default class Dashboard extends BaseComponent {
  valid: boolean = false;
  searchCriteria = new SearchVcClaimInput();
  counties = util.abp.constant.oKCounty.values;
  claims?: VcClaimSummaryLightDto[] = [];

  async created() {
    this.refreshTaskCounts();
    this.doDefaultSearch();
  }

  mounted() {
    bus.$on("refreshList", () => {
      this.refreshTaskCounts();
      this.doDefaultSearch();
    });
  }

  beforeDestroy() {
    bus.$off("refreshList");
  }

  refreshTaskCounts() {
    this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
  }

  private async doDefaultSearch() {
    const dashboardInput: IPagedAndSortedInputDto = {
      maxResultCount: 1000,
      skipCount: 0,
      sorting: "CreationTime DESC"
    };
    const searchRes = await this.$appsvs.vcpOnlineOkStaff.searchVcClaims(
      <PagedAndSortedInputDto>dashboardInput
    );
    this.claims = searchRes.items;
  }

  async onSubmitSearch() {
    if (!this.isObjectEmpty(this.searchCriteria)) {
      this.searchCriteria.maxResultCount = 1000;
      const res = await this.$appsvs.vcpOnlineOkStaff.searchVcClaims(
        this.searchCriteria
      );
      this.claims = res.items;
    } else {
      this.doDefaultSearch();
    }
  }

  clearSearch() {
    // if (!this.isObjectEmpty(this.searchCriteria)) {
    this.searchCriteria = new SearchVcClaimInput();
    this.doDefaultSearch();
    // }
  }

  async openClaimSummary(claimNumber: string) {
    this.$router.push({
      name: "ClaimSummary",
      params: { claimNumber: claimNumber }
    });
  }
}
